var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSidorovArtem(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 8,
    fill: "#F6F7FB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0078 26.25C13.3672 26.25 12.0677 25.724 11.1094 24.6719C10.151 23.6146 9.67188 22.1771 9.67188 20.3594C9.67188 18.5469 10.1536 17.112 11.1172 16.0547C12.0755 15.0026 13.3724 14.4766 15.0078 14.4766C16.3255 14.4766 17.4401 14.8516 18.3516 15.6016C19.263 16.3568 19.7943 17.3333 19.9453 18.5312H17.625C17.474 17.9115 17.1641 17.4141 16.6953 17.0391C16.2161 16.6693 15.6536 16.4844 15.0078 16.4844C14.1172 16.4844 13.4089 16.8307 12.8828 17.5234C12.3516 18.2214 12.0859 19.1641 12.0859 20.3516C12.0859 21.5547 12.349 22.5026 12.875 23.1953C13.401 23.8932 14.1146 24.2422 15.0156 24.2422C15.6771 24.2422 16.2396 24.0703 16.7031 23.7266C17.1615 23.388 17.4714 22.9167 17.6328 22.3125H19.9531C19.7708 23.5208 19.237 24.4766 18.3516 25.1797C17.4609 25.8932 16.3464 26.25 15.0078 26.25ZM27.7812 23.2656H23.8203L22.9609 26H20.5391L24.4531 14.7266H27.2266L31.1484 26H28.6406L27.7812 23.2656ZM24.3281 21.5H27.2734L25.8281 16.8828H25.7734L24.3281 21.5Z",
    fill: "#4B9BF5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidorovArtem);
export default __webpack_public_path__ + "static/media/SidorovArtem.e2bad4de8441fb718c7c969111223b0f.svg";
export { ForwardRef as ReactComponent };